module.exports = __webpack_public_path__ + "img/japan.c59fab24.png";